var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 260,
    viewBox: "0 0 340 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1321_9531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 32C40 25.3726 45.3726 20 52 20H288C294.627 20 300 25.3726 300 32V188C300 194.627 294.627 200 288 200H52C45.3726 200 40 194.627 40 188V32Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 60C72.0294 60 68 64.0294 68 69C68 73.9706 72.0294 78 77 78C81.9706 78 86 73.9706 86 69C86 64.0294 81.9706 60 77 60ZM107 60C102.029 60 98 64.0294 98 69C98 73.9706 102.029 78 107 78H241C245.971 78 250 73.9706 250 69C250 64.0294 245.971 60 241 60H107Z",
    fill: "url(#paint0_linear_1321_9531)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 94C72.0294 94 68 98.0294 68 103C68 107.971 72.0294 112 77 112C81.9706 112 86 107.971 86 103C86 98.0294 81.9706 94 77 94ZM107 94C102.029 94 98 98.0294 98 103C98 107.971 102.029 112 107 112H241C245.971 112 250 107.971 250 103C250 98.0294 245.971 94 241 94H107Z",
    fill: "url(#paint1_linear_1321_9531)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 128C72.0294 128 68 132.029 68 137C68 141.971 72.0294 146 77 146C81.9706 146 86 141.971 86 137C86 132.029 81.9706 128 77 128ZM107 128C102.029 128 98 132.029 98 137C98 141.971 102.029 146 107 146H241C245.971 146 250 141.971 250 137C250 132.029 245.971 128 241 128H107Z",
    fill: "url(#paint2_linear_1321_9531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1321_9531",
    x: 0,
    y: 0,
    width: 340,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.564706 0 0 0 0 0.984314 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1321_9531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1321_9531",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1321_9531",
    x1: 68,
    y1: 69,
    x2: 250,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1321_9531",
    x1: 68,
    y1: 103,
    x2: 250,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1321_9531",
    x1: 68,
    y1: 137,
    x2: 250,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.a71496e9e795a11c18e7487c1389577f.svg";
export { ForwardRef as ReactComponent };